export const stateHighlight = {
        "id": "stateHighlight",
        "source": "summaryStats",
        "source-layer": "summary_stats",
        "type": "fill",
        "interactive": true,
        "layout": {
          "visibility": "visible"
        },
        "metadata": { 
          "style": "none",
          "name": "County-level Values"
        },
        "paint": {
          "fill-outline-color": "#ffff00",
          "fill-color": "hsla(120, 60%, 70%, 0.0)"
        }
  }